import { useNavigate, useParams } from "react-router-dom";
import { useGetDestinationsWithImageQuery } from "../../apiCaller/apis/getApi";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import DestinationComponent from "../../components/eventCard/DestinationComponent";
import EventComponent from "../../components/eventCard/EventComponent";
import ClientLayout from "../../components/Layout/ClientLayout";
import SearchBarComponent from "../../components/searchBar/SearchBarComponent";
import { useEffect, useState } from "react";
import PaginationComponent from "../../components/pagination";
import SpinningLoader from "../../components/SpinningLoader/SpinningLoader";
import DestinationSearchBarComponent from "../../components/searchBar/DestinationSearchBarComponent";

const DestinationList = () => {
  const [countryLabel, setCountryLabel] = useState();
  const { country } = useParams();
  const [search, setSearch] = useState({
    isTraverse: false,
    country: country,
    totalItems: 8,
  });
  const {
    data: destinations,
    error: destinationError,
    isLoading: destinationIsLoading,
    isFetching: destinationIsFetching,
  } = GetTableListAPI(
    search,
    useGetDestinationsWithImageQuery
  );

  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/destinations/${id}`);
  };

  
  useEffect(() => {
    switch (country) {
      case "ke":
        setCountryLabel("Kenyan");
        break;
      case "tz":
        setCountryLabel("Tanzanian");
        break;
      case "ug":
        setCountryLabel("Uganda");
        break;
      case "rw":
        setCountryLabel("Rwanda");
        break;
      default:
        setCountryLabel("All");
    }
  });

  const handlePageClick = (page) => {
    const newSearch = { ...search, page: page + 1 };
    setSearch(newSearch);
  };

  const handleSearch = (params) => {
    // console.log(params)
    const newSearch = { ...search, ...params };
    setSearch(newSearch);
  }; 
  return (
    <ClientLayout>
      <div className="px-5">
        {/* HERO COMPONENT */}
        <div className="bg-destination-image h-[250px] lg:h-[300px] bg-cover bg-center rounded-lg relative w-full">
          <div class="absolute inset-0 bg-color-primary-dark2 opacity-20"></div>
          <div className="text-5xl font-bold text-white z-100 flex justify-center items-center h-full text-center">
            {countryLabel} Destinations
          </div>
        </div>

        {/* SEARCH COMPONENT */}
        <div className="px-10 md:px-16 lg:px-48 py-10 w-full">
          <div className="">
            <DestinationSearchBarComponent handleSearch={handleSearch} />
          </div>

          {/* DESTINATION LIST */}
          {destinationIsLoading || destinationIsFetching ? (
            <SpinningLoader isLoading={true} hasData={false} />
          ) : (
            <div className="my-10 flex flex-wrap gap-10 items-stretch w-full">
              {destinations && destinations.results.length > 0 ? (
                destinations.results.map((destination, index) => (
                  <div
                    key={index}
                    className="w-full sm:w-[48%] lg:w-[23%] cursor-pointer"
                    onClick={() => handleClick(destination.id)}
                  >
                    <DestinationComponent destination={destination} />
                  </div>
                ))
              ) : (
                <div className="text-center w-full">No events</div>
              )}
            </div>
          )}

          <div>
            <PaginationComponent
              pageCount={destinations?.totalPages}
              totalItems={destinations?.totalItems}
              handlePageClick={handlePageClick}
            />
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default DestinationList;
